var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7981 1.30204C10.9137 4.45101 14.8783 7.01557 17.7936 8.5308L17.7931 9.93036C14.8769 11.2142 11.0273 13.6647 11.0263 16.6971L8.92699 16.6978C8.81147 13.3156 12.3111 10.9818 14.7606 10.1646L1.69815 9.93565L1.69884 7.83631L14.7613 8.06528C12.1957 7.36634 8.58105 4.68504 8.69879 1.30273L10.7981 1.30204Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.ad755781e1d4ba52539d7e4248d53ace.svg";
export { ForwardRef as ReactComponent };